export default __webpack_public_path__ + "media/images/home/slide_winter_2026_lg-4e57b6ee0f4e0c04bd73340ef7a40a6a.jpg";